import { Amenity } from '@apis/index'
import { edit, outlinenotification, switchOff, switchOn } from '@assets/icons'
import Svg from '@components/svg'
import Table from '@components/table'
import Wrapper from '@components/wrapper'
import useScrollToTop from '@hooks/useScrollToTop'

import React, { Fragment, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from '@store'

const AmenityList = () => {
  const scrollToTop = useScrollToTop()

  const navigate = useNavigate()
  const { data: banners, loading } = useSelector(
    (state: RootState) => state.amenities,
  )

  const fetchAmenities = async () => {
    try {
      await Amenity.list({ state: 'amenities' })
    } catch (error) {}
  }

  const columns = [
    {
      title: 'SN',
      key: 'sn',
      render: (
        _: any,
        i:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal,
      ) => <p>{i}</p>,
    },
    {
      title: 'Amenity name',
      key: 'name',
      render: (item) => item?.name ?? 'N/A',
    },
    {
      title: 'Banner Image',
      key: 'image',
      render: (item: { image: any }) => (
        <img
          src={`${process.env.APP_BUCKET_URL}/${item.image}`}
          alt="amenity-image"
          width={100}
        />
      ),
    },

    {
      title: 'Status',
      key: 'status',
      render: (item: { status: any; id: any }) => (
        <Svg
          src={item.status ? switchOn : switchOff}
          onClick={async () =>
            await Amenity.update({
              id: item.id,
              state: 'amenities',
              data: { status: !item.status },
            })
          }
        />
      ),
    },
  ]

  const data = banners.map((b) => ({
    id: b.id,
    image: b.icon,
    status: b.status,
    name: b.name,
  }))

  useEffect(() => {
    fetchAmenities().then(() => {})
  }, [])

  return (
    <Fragment>
      <Wrapper>
        <Table
          loading={loading}
          searchKeys={['link']}
          text="Banner List"
          icon={outlinenotification}
          columns={columns}
          data={data}
          actions={[
            {
              icon: edit,
              key: 'edit',
              onClick: (item) => {
                navigate(`/admin/amenity-setup/${item.id}`, { state: item })
                scrollToTop()
              },
            },
          ]}
        />
      </Wrapper>
    </Fragment>
  )
}

export default AmenityList
